import { lazyNamed } from 'src/utils/lazyNamed.ts';

export const Availabilities = {
  List: lazyNamed(() => import('./containers/AvailabilitiesList/index.tsx'), 'AvailabilitiesList'),
};
